fx.ns("shared.popups", class FileUploadFailed extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 225;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Un problème est survenu"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Je n'ai pas pu importer votre fichier. Veuillez ré-essayer ou contacter le <a href='/contact' target='_blank'>service client</a>."), className:"text center"}));

        this.addFooterChild("close");
    }

    onClose()
    {
        super.onClose();

        this.data.event("show-editor")
    }
});